import { Compass, HeartHandshake, School } from "lucide-react";

const items = [
  {
    icon: Compass,
    eyebrow: "You have ADHD. Now what?",
    title: "Navigating diagnosis (new or lifelong)",
    body:
      "Whether your diagnosis is fresh or you've been working with it for years, we'll build understanding, language, and strategies that fit your brain.",
  },
  {
    icon: HeartHandshake,
    eyebrow: "Supporting a child with ADHD isn't easy",
    title: "Calmer, more connected family life",
    body:
      "Find tools to uncover your parenting strengths, foster empathy, and create the kind of home where everyone (kid and parent) can breathe.",
  },
  {
    icon: School,
    eyebrow: "Classroom chaos leaving you overwhelmed?",
    title: "Turn the classroom into calm",
    body:
      "Practical, ADHD-friendly strategies that break through the walls of overwhelm, for educators who want their classroom to feel like home base.",
  },
];

export default function Obstacles() {
  return (
    <section
      id="obstacles"
      data-testid="obstacles-section"
      className="py-24 md:py-32 bg-white/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl reveal">
          <span className="text-xs md:text-sm uppercase tracking-[0.28em] text-brand-coral font-semibold">
            Overcome your obstacles
          </span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl lg:text-6xl text-brand-navy tracking-tight leading-[1.05]">
            You don't have to navigate this alone.
          </h2>
          <p className="mt-6 text-lg text-brand-navy/70 max-w-2xl">
            Wherever you are on the journey (diagnosis, parenting, classroom),
            there's a way through. Here's where most people start.
          </p>
        </div>

        <div className="mt-14 md:mt-20 grid md:grid-cols-3 gap-6 md:gap-8">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <article
                key={it.title}
                data-testid={`obstacle-card-${i}`}
                className="reveal group relative rounded-3xl bg-white border border-brand-sage/15 p-8 md:p-10 shadow-[0_8px_30px_rgba(47,66,80,0.05)] hover:-translate-y-2 hover:shadow-[0_24px_48px_rgba(47,66,80,0.08)] transition-all duration-500"
              >
                <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-brand-cream border border-brand-sage/20 text-brand-coral group-hover:bg-brand-coral group-hover:text-brand-cream transition-colors duration-500">
                  <Icon size={24} strokeWidth={1.6} />
                </div>
                <div className="mt-6 text-xs uppercase tracking-[0.2em] text-brand-sage font-semibold">
                  {it.eyebrow}
                </div>
                <h3 className="mt-3 font-serif text-2xl md:text-3xl text-brand-navy leading-snug">
                  {it.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-brand-navy/70">
                  {it.body}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
